import { useI18n } from 'vue-i18n'

export default class CourseMaster {
  constructor(obj?: Partial<CourseMaster>) {
    Object.assign(this, obj)
  }

  courseId = ''

  courseName = {} as {
    [key: string]: string | null
  }

  parentOrganization = ''

  startDate: number | null = null

  endDate: number | null = null

  planDuration: number | null = null

  readOnlyDuration: number | null = null

  planEndDate: number | null = null

  readOnlyEndDate: number | null = null

  /**
   * 表示名
   */
  get name() {
    const { locale } = useI18n()
    return this.courseName[locale.value] || this.courseName.en
  }
}
